import { useTranslation } from "gatsby-plugin-react-i18next";
import React from "react";

const PrivacyPolicy: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <a
                href={
                    process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                        ? "https://www.baloise.be/nl/over-ons/privacy.html"
                        : "https://www.baloise.be/fr/a-propos-de-nous/privacy.html"
                }
                className="link"
                target="_blank"
                rel="noreferrer"
            >
                {t("privacypolicy")}
            </a>
        </>
    );
};

export default PrivacyPolicy;
